<form 
    (ngSubmit)="$event.preventDefault(); saveSummarySignature();"
    [formGroup]="summarySignatureForm"
    class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto"
>
    <div class="w-full overflow-y-auto px-1">                    
        <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
            Official Signature(s):
        </h2>
        <div class="w-full flex flex-col items-center gap-4 pb-4"> 
            <div class="w-full flex flex-col items-start text-start">
                <div class="font-semibold">
                    <p>By typing my name, I am acknowledging my participation in this form. *</p>
                </div>
                <div class="w-full flex flex-col items-center">
                    <input 
                        type="text"
                        formControlName="user_signature_name"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                        placeholder="Your Full Name..."
                    >
                </div>
            </div>

            <div class="w-full flex flex-col items-start text-start gap-2">                  
                <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
                    Previous Signature:
                </h2>
                <div class="w-full flex items-center text-start gap-2">
                    <div class="w-fit font-semibold whitespace-nowrap">
                        <p>Signature:</p>
                    </div>
                    <p class="w-full">{{ threatAssessmentSummaryData.user_signature_name }}</p>
                </div>
                <div class="w-full flex items-center text-start gap-2">
                    <div class="w-fit font-semibold whitespace-nowrap">
                        <p>Name:</p>
                    </div>
                    <p class="w-full">{{ threatAssessmentSummaryData.user_fullname }}</p>
                </div>
                <div class="w-full flex items-center text-start gap-2">
                    <div class="w-fit font-semibold whitespace-nowrap">
                        <p>Email address:</p>
                    </div>
                    <p class="w-full">{{ threatAssessmentSummaryData.user_email }}</p>
                </div>
                <div class="w-full flex items-center text-start gap-2">
                    <div class="w-fit font-semibold whitespace-nowrap">
                        <p>Title:</p>
                    </div>
                    <p class="w-full">{{ threatAssessmentSummaryData.user_title }}</p>
                </div>
                <div class="w-full flex items-center text-start gap-2">
                    <div class="w-fit font-semibold whitespace-nowrap">
                        <p>Workphone:</p>
                    </div>
                    <p class="w-full">{{ threatAssessmentSummaryData.user_workphone }}</p>
                </div>
                <div class="w-full flex items-center text-start gap-2">
                    <div class="w-fit font-semibold whitespace-nowrap">
                        <p>Date & time:</p>
                    </div>
                    <p class="w-full">{{ threatAssessmentSummaryData.date_time_signed | date: 'MM/dd/yyyy - HH:mm' }}</p>
                </div>
            </div>
        </div>
        <div class="w-full flex flex-row gap-2 items-center justify-end">
            <button
                type="submit"
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                [ngClass]="{
                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.summarySignatureForm.invalid,
                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.summarySignatureForm.valid
                }"
                [disabled]="this.summarySignatureForm.invalid"
            >
                Save
            </button>
        </div>
    </div>
</form>

<div *ngIf="loading">
    <spinner></spinner>
</div>